  // Build the dynamic selector string
  var observerTargetSelector = "#pplr-" + window.productId;

  // Create an observer to monitor changes in the DOM
  const chElementObserver = new MutationObserver((mutations, obs) => {
    try {
      var chFindElement = document.querySelector('#Monogram_inputs');

      if (chFindElement) {
        let chDashInsert = document.getElementsByClassName("pplr-wrapper pplr-text pplr--monogram pplr-collapsible")[0];
        if (chDashInsert) {
          let chInjectDiv = document.createElement('div');
          chInjectDiv.classList.add("injection_container");
          chInjectDiv.innerHTML = chFindElement.innerHTML;
          chDashInsert.parentNode.insertBefore(chInjectDiv, chDashInsert.nextSibling);
          
          var OldInput = document.getElementsByClassName('pplr-wrapper pplr-text pplr--monogram pplr-collapsible')[0];
          OldInput.classList.add("personalization_input_container_hidden");
          document.getElementsByClassName('pplrlabel')[1].classList.add("pplrlabel_hidden");
          document.getElementsByClassName('btn pplr-c-button pplr-btn button Button--secondary ptc_button')[0]
            .setAttribute("onclick", "cstmfy_personalize_text(this,event); focus_personalization()");
          document.getElementsByClassName('pplr-wrapper mcolor pplr-color-select pplr-+-monogram pplr-collapsible')[0]
            .classList.remove("pplr-hide");

          const tooltips = document.getElementsByClassName('swtooltip');
          for (let i = 0; i < tooltips.length; i++) {
            tooltips[i].classList.add("hide_tooltip");
          }

          document.getElementsByClassName('pplr-swatch-element pplrColor  color_display_circle')[0].classList.add("selected");
          
          var monogramNotice = document.querySelector('#Monogram_Notice');
          let insertionPointNotice = document.getElementsByClassName("pplrgcolor  pplr-swatch-main")[0];
          let noticeInjection = document.createElement('div');
          noticeInjection.classList.add("injection_container_notice");
          noticeInjection.innerHTML = monogramNotice.innerHTML;
          insertionPointNotice.parentNode.insertBefore(noticeInjection, insertionPointNotice.nextSibling);
          
          document.getElementsByName('Monogram_Input_1')[1].focus();

          obs.disconnect();
          return;
        }
      }
    } catch(e) {
      console.log(e);
      obs.disconnect();
    }
  });

  // Start observing the product's specific DOM element
  chElementObserver.observe(document.querySelector(observerTargetSelector), {
    childList: true,
    subtree: true
  });